import { AxiosPDFReport, getRequest, postRequest } from '../../Axios';
import { roundNumber } from '../../../../util/DaFrameword';

export const RESET_ADVANCE_APPLICATION = 'RESET_CXP_ADVANCE_APPLICATION';
export const UPDATE_ADVANCE_APPLICATION = 'UPDATE_CXP_ADVANCE_APPLICATION';

export const ResetAdvanceApplication = (sessionId, preserveRates = false, previousSessionId) => ({
  type: RESET_ADVANCE_APPLICATION, sessionId, preserveRates, previousSessionId
});
export const UpdateAdvanceApplication = (sessionId, payload) => ({
  type: UPDATE_ADVANCE_APPLICATION, sessionId, payload
});

export const GetAvailable = params => dispatch => dispatch(getRequest('/CXPAdvanceApplication/Available', params))
  .then(({ payload: { data } }) => data);
export const GetInvoices = params => dispatch => dispatch(getRequest('/CXPAdvanceApplication/Invoices', params))
  .then(({ payload: { data } }) => data);
export const GetHistory = params => dispatch => dispatch(getRequest('/CXPAdvanceApplication/History', params))
  .then(({ payload: { data } }) => data);
export const GetCurrencyRates = () => dispatch => dispatch(getRequest('/Currency/GetCurrencyWithTax', {}))
  .then(({ payload: { data } }) => Object.fromEntries((data || [])
    .map(currency => [currency.id, roundNumber(Number(currency.currencyValuation || 1), 2)])));
export const ApplyApplication = params => dispatch => dispatch(postRequest('/CXPAdvanceApplication/Apply', {}, params))
  .then(({ payload: { data } }) => data);
export const ReverseApplication = params => dispatch => dispatch(postRequest('/CXPAdvanceApplication/Reverse', {}, params))
  .then(({ payload: { data } }) => data);
export const CreatePdf = (params, dispatch) => AxiosPDFReport('CXPAdvanceApplication/Pdf', params, dispatch);
